import { getReportName } from "./functions";

type Translate = (key: string) => string;

const reportNotificationStatuses: Record<string, string> = {
  "report.completed": "completed",
  "report.empty": "empty",
  "report.failed": "failed",
};

export function getReportNotificationStatus(type: string): string | null {
  return reportNotificationStatuses[type] ?? null;
}

export function getReportNotificationLabel(type: string, translate: Translate, reportType?: string | number | null): string | null {
  const status = getReportNotificationStatus(type);
  if (!status) return null;

  const reportName = reportType === undefined || reportType === null || reportType === ""
    ? null
    : getReportName(String(reportType), translate);

  return `${translate("Report")}${reportName ? ` · ${reportName}` : ""} · ${translate(status)}`;
}

export function getReportNotificationPath(notification: {
  type: string | number;
  report_id?: string | number | null;
  report_turn?: string | number | null;
  report_type?: string | number | null;
  report_device_id?: string | number | null;
}): string | null {
  if (
    getReportNotificationStatus(String(notification.type)) === null
    || notification.report_id === null || notification.report_id === undefined
    || notification.report_turn === null || notification.report_turn === undefined
    || notification.report_type === null || notification.report_type === undefined
    || notification.report_device_id === null || notification.report_device_id === undefined
  ) {
    return null;
  }

  return `/report/${encodeURIComponent(String(notification.report_id))}/${encodeURIComponent(String(notification.report_turn))}/${encodeURIComponent(String(notification.report_type))}/${encodeURIComponent(String(notification.report_device_id))}`;
}
